import React from 'react';

import { useIntl } from 'react-intl';

import { IConfirmationUIProps } from 'pages/order-confirmation/order-confirmation';
import OrderIssues from 'pages/order-confirmation/order-issues';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { OrderConfirmationHeader } from '../components/order-confirmation-header';
import { OrderDetailsCard } from '../components/order-details-card';
import { ServiceModeHeading } from '../components/service-mode-heading';
import { Container, Section, SectionTitle } from '../styled';

import DeliveryDisclaimer from './delivery-disclaimer';
import { DeliveryOrderCard } from './delivery-order-card';

const DeliveryConfirmation: React.FC<React.PropsWithChildren<IConfirmationUIProps>> = ({
  serverOrder,
}) => {
  const isShowingOrderingIssue = useFlag(LaunchDarklyFlag.SHOW_ORDERING_ISSUE);
  const { formatMessage } = useIntl();

  return (
    <Container>
      <Section>
        <OrderConfirmationHeader serverOrder={serverOrder} />
      </Section>

      <Section>
        <ServiceModeHeading serviceMode={serverOrder.cart.serviceMode} />
        <DeliveryOrderCard serverOrder={serverOrder} />
      </Section>

      <Section>
        <SectionTitle focusable>{formatMessage({ id: 'order' })}</SectionTitle>
        <OrderDetailsCard order={serverOrder} />
      </Section>

      <Section>
        {isShowingOrderingIssue && (
          <OrderIssues>
            <DeliveryDisclaimer />
          </OrderIssues>
        )}
      </Section>
    </Container>
  );
};

export default DeliveryConfirmation;
